import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../../utils/firebase/firebase.config";
import Compressor from "react-image-file-resizer";

export const uploadImageHandler = (
  pathRef,
  imageName,
  imageData,
  sendImageUrl,
  setIsImageUploading,
  setUploadStatus,
  nullImageData
) => {
  // Allowed image types
  const allowedExtensions = ['image/png', 'image/jpeg', 'image/jpg'];

  // Check the file type
  if (!allowedExtensions.includes(imageData.type)) {
    setIsImageUploading(false);
    setUploadStatus({
      isError: true,
      message: "File extension should be .jpeg, .jpg, .png"
    })
    throw new Error("File extension should be .jpeg, .jpg, .png");
  }

  // Proceed with image compression and upload if the file type is valid
  Compressor.imageFileResizer(
    imageData, // the file from input
    720, // width
    932, // height
    // imageFormate, // compress format WEBP, JPEG, PNG
    "WEBP",
    65, // quality
    0, // rotation
    (uri) => {
      // console.log(uri);
      const storageRef = ref(storage, `${pathRef}/${imageName}`);
      const uploadTask = uploadBytesResumable(storageRef, uri);
      // You upload logic goes here
      uploadTask.on(
        "state_changed",
        (snap) => {
          console.log(snap);
          // Optional: Set uploading status or progress
        },
        (err) => {
          console.log("Error during image upload initialization: ", err);
          setIsImageUploading(false);
          setUploadStatus({
            isError: true,
            message: err
          })
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            // console.log("downloadURL: ", downloadURL)
            sendImageUrl(downloadURL);
            setIsImageUploading(false);
            if (nullImageData) {
              nullImageData();
            }
          } catch (err) {
            console.log("Error during firebase image upload: ", err);
            setIsImageUploading(false);
            setUploadStatus({
              isError: true,
              message: err
            })
          }
        }
      );
    },
    "blob" // blob or base64 default base64
  );
};
